import { CloneOutputTemplatePage } from './CloneOutputTemplatePage';
import { CreateOutputTemplatePage } from './CreateOutputTemplatePage';
import { CreateOutputTemplateVariantPage } from './CreateOutputTemplateVariantPage';
import { OutputTemplateDetailsPage } from './OutputTemplateDetailsPage';

export const outputTemplateRoutes = [
  {
    path: 'create',
    element: <CreateOutputTemplatePage />,
  },
  {
    path: 'clone/:outputTemplateId',
    element: <CloneOutputTemplatePage />,
  },
  {
    path: 'clone/:outputTemplateId/variant/:variantNumber',
    element: <CreateOutputTemplateVariantPage />,
  },
  {
    path: 'edit/:outputTemplateId/variant/:variantNumber',
    element: <CreateOutputTemplateVariantPage />,
  },
  {
    path: ':outputTemplateId',
    element: <OutputTemplateDetailsPage />,
  },
  {
    path: ':outputTemplateId/variant/:variantNumber',
    element: <OutputTemplateDetailsPage />,
  },
];
